import request from '@/router/axios'

let urlPrefix = '/api/lab/lesson'

export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
            publicFlag: 0, // 只显示公开课堂
        }
    })
}

/**
 *
 * @param page
 * @param limit
 * @param params
 */
export const getAllList = (page, limit, params) => {
    return request(`${urlPrefix}/queryAll`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}

export const getMyList = (page, limit, params) => {
    return request(`${urlPrefix}/mine/create`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

/**
 * 获取个人课堂列表
 */
export const getMyLesson = (page, limit, params) => {
    return request(`${urlPrefix}/getJoinLessons`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}


export const add = (data) => {
    return request(urlPrefix, { data }, 'post')
}

export const update = (data) => {
    return request(urlPrefix, { data }, 'put')
}

/**
 * 课堂名称检查
 * @param {*} name 
 * @param {*} id 
 */
export const duplicateCheck = (name, id) => {
    return request(`${urlPrefix}/duplicateCheck`, {
        params: {
            id,
            lessonName: name
        }
    })
}

export const getEntity = id => {
    return request(`${urlPrefix}/${id}`)
}

export const getDetail = uid => {
    return request(`${urlPrefix}/detail/${uid}`)
}

export const remove = (data) => {
    return request(`${urlPrefix}/deleteBatchByUid`, {
        data
    }, 'delete')
}

/**
 * 结课
 * @param {*} data 
 */
export const end = data => {
    return request(`${urlPrefix}/end`, {
        data
    }, 'put')
}

/**
 * 检查课堂状态
 * @param {*} uid 
 */
export const checkLesson = uid => {
    return request(`${urlPrefix}/check/${uid}`)
}

/**
 * 加入公开课
 * @param {String} uid 课程UID
 */
export const joinPublicLesson = (uid) => {
    return request(`${urlPrefix}/joinLesson/public/${uid}`, null, 'post')
}

/**
 * 加入私有课
 * @param {String} code 课程邀请码
 */
export const joinPrivateLesson = (code) => {
    return request(`${urlPrefix}/joinLesson/private/${code}`, null, 'post')
}

/**
 * 获取课堂下学生列表
 * @param {String} uid 课堂uid
 */
export const getLessonStudents = (uid) => {
    return request(`${urlPrefix}/getStudents/${uid}`)
}

/**
 * 分页查询获取课堂的学生列表
 * @param {*} page 
 * @param {*} limit 
 * @param {*} params 
 */
export const getPageCheckStudentList = (page, limit, params) => {
    return request(`${urlPrefix}/getStudents`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

// 查询该部门下的课程
export const getDeptLessonList = (page, limit, params) => {
    return request(`${urlPrefix}/queryDeptLesson`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

// 查询该部门下的课程
export const getDeptRecomLessonList = (page, limit, params) => {
    return request(`${urlPrefix}/queryDeptRecomLesson`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

/**
 * 模糊查询：搜索感兴趣的课程
 * @deprecated 该方法已弃用，请使用 getAllList 方法代替
 * @see getAllList
 * @param page
 * @param limit
 * @param params
 */
export const getLikeList = (page, limit, params) => {
    return request(`${urlPrefix}/queryLike`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}
